import type { ProfilePicture } from "../Types/ProfilePicture";

export const profilePicture: ProfilePicture = {
  name: "Gustav Weber Kinch",
  image: { src: "/profilePicture.jpg", title: "Gustav Weber Kinch" },
};
